import { render, staticRenderFns } from "./ortaMenuler.vue?vue&type=template&id=2b15209c&scoped=true&"
import script from "./ortaMenuler.vue?vue&type=script&lang=js&"
export * from "./ortaMenuler.vue?vue&type=script&lang=js&"
import style0 from "./ortaMenuler.vue?vue&type=style&index=0&id=2b15209c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b15209c",
  null
  
)

export default component.exports